import React, { useState, useEffect } from "react";
import { Table, Form, Card, Spinner, Button } from "react-bootstrap";
import LocalStorageService from "../../../Auth/auth_service/AuthServiceStorage";
import AxiosService from "../../../Utils/AxiosService";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import Select from "react-select";

const tableCellStyle = {
  padding: "3px 5px",
  fontSize: "14px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const tableHeaderStyle = {
  backgroundColor: "#f5f5f5",
  padding: "3px 5px",
  fontSize: "14px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const MasterLabelReportSimplified = () => {
  const apiService = new AxiosService();
  const [data, setData] = useState({});
  const [fileLogData,setFileLogData]= useState({});
  const [clientFilter, setClientFilter] = useState("");
  const [countryFilter, setCountryFilter] = useState([]);
  const [loader, setLoader] = useState(false);
   const authDetails = LocalStorageService.getAuthDetails();
const [dynamicLabelConfig, setDynamicLabelConfig] = useState(
    {
      New: "",
      Pending: "",
      Reassigned: "",
      Completed: "",
      InputLabels : "",
      WorkInProgress:"",
      Excluded:""
    })

     const getCountryParts = (country) => {
    if (!country) return { name: "", code: "" };
    const [name, code] = country.split("#");
    return {
      name,
      code: code === "GER" ? "DE" : code,
    };
  };

  const calculateCounts = (stats) => {
    const counts ={
    new: stats.F ? stats.F.length : 0,
    reassigned: stats.R ? stats.R.length : 0,
    pending: stats.N ? stats.N.length : 0,
    completed: stats.Y ? stats.Y.length : 0,
    inputLabels :stats.C ? stats.C.length : 0,
    workInProgress : stats.W ? stats.W.length:0,
    excluded: stats.EXCLUDED ? stats.EXCLUDED.length : 0
    };
 counts.total =
    counts.new +
    counts.reassigned +
    counts.pending +
    counts.completed +
    counts.inputLabels +
    counts.workInProgress+
    counts.excluded
    
  return counts;
  };

  const getTotalCounts = (data) =>
    Object.values(data).reduce(
      (total, countries) => {
        Object.values(countries).forEach((stats) => {
          total.new += stats.F ? stats.F.length : 0;
          total.reassigned += stats.R ? stats.R.length : 0;
          total.pending += stats.N ? stats.N.length : 0;
          total.completed += stats.Y ? stats.Y.length : 0;
          total.inputLabels += stats.C ? stats.C.length : 0;
          total.workInProgress += stats.W ? stats.W.length : 0;
          total.excluded += stats.EXCLUDED ? stats.EXCLUDED.length : 0;
          
        });
        return total;
      },
      { new: 0, reassigned: 0, pending: 0, completed: 0 ,inputLabels :0,workInProgress:0,excluded: 0 }
    );

  useEffect(() => {
    const fetchMasterLabelReport = () => {
      const authVal = LocalStorageService.getAuthDetails();
      if (authVal) {
        setLoader(true);
        let authDetails = JSON.parse(authVal);
        apiService
          .getMasterLabelReport(authDetails.id)
          .then((response) => {
            setData(response.data || {});
            setLoader(false);
          })
          .catch((error) => {
            toast.error(
              error?.response?.data?.message || "Something went wrong!"
            );
            setLoader(false);
          });
          apiService.getFileUploadLogLabel()
           .then((response) => {
            setFileLogData(response.data || {});
              })
              .catch((error) => {
            toast.error(
              error?.response?.data?.message || "Something went wrong!"
            );
            setLoader(false);
          });
      }
    };
    fetchMasterLabelReport();
    getdefaultDynamicLabelConfig();
  }, []);

  const getdefaultDynamicLabelConfig = () => {
      const auth_details = JSON.parse(authDetails);
  
      apiService
        .getDynamicLabelConfig(auth_details.roles)
        .then((response) => {
          if (response.data) {
            setDynamicLabelConfig({
            New: response.data.newLabel,
            Pending: response.data.pendingLabel,
            Reassigned: response.data.reassignedLabel,
            Completed: response.data.completedLabel,
          });
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
          } else {
            toast.error("Something went wrong!");
          }
        });
    };

  const getDynamicLabelConfig = () => {
    if(clientFilter && countryFilter){
     apiService.getDynamicLabelConfig(`${clientFilter}-${countryFilter.map(c => c.value.split("#")[1]).join(",")}`)
      .then((response) => {
        if (response.data) {
          setDynamicLabelConfig({
            New: response.data.newLabel,
            Pending: response.data.pendingLabel,
            Reassigned: response.data.reassignedLabel,
            Completed: response.data.completedLabel,
          });
        }
      })
      .catch((error) => {

        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong!");
        }
      });
    }
  };

  useEffect(() => {
        getDynamicLabelConfig()
  }, [clientFilter ,countryFilter])
  

  const filteredData = Object.entries(data).reduce(
    (acc, [category, countries]) => {
      if (
        clientFilter &&
        !category.toLowerCase().includes(clientFilter.toLowerCase())
      )
        return acc;
      const filteredCountries = Object.entries(countries).reduce(
        (countryAcc, [country, stats]) => {
          // const countryName = country === "GER" ? "DE" : country;
          if (countryFilter.length > 0) {
            const match = countryFilter.some((selected) => {
              const searchVal =
                selected.value === "DE" ? "GER" : selected.value;
              return country.toLowerCase().includes(searchVal.toLowerCase());
            });
            if (!match) return countryAcc;
          }
          return { ...countryAcc, [country]: stats };
        },
        {}
      );
      if (Object.keys(filteredCountries).length > 0)
        acc[category] = filteredCountries;
      return acc;
    },
    {}
  );

  const totalCounts = getTotalCounts(filteredData);

  const grandTotal =
  totalCounts.inputLabels +
  totalCounts.workInProgress +
  totalCounts.new +
  totalCounts.pending +
  totalCounts.reassigned +
  totalCounts.completed +
  totalCounts.excluded;

  // A "Create" label becomes "Create-Client" when its file-upload log entry
  // was uploaded by a user other than user 1 (i.e. the client themselves).
  const isClientCreatedLabel = (label) => {
    const logs = Array.isArray(fileLogData)
      ? fileLogData
      : Object.values(fileLogData || {});
    return logs.some(
      (entry) =>
        entry &&
        entry.tradeName === label &&
        Number(entry.userId) !== 1
    );
  };

  // function handleExportToExcel() {
  //   const summaryRows = [];
  //   const detailRows = [];

  //   // Create summary sheet data
  //   Object.entries(filteredData).forEach(([category, countries]) => {
  //     Object.entries(countries).forEach(([country, stats]) => {
  //       const counts = calculateCounts(stats);
  //       const total = Object.values(counts).reduce((sum, c) => sum + c, 0);
  //       if (total === 0) return;
  //       country = country === "GER" ? "DE" : country;
  //       summaryRows.push({
  //         Client: category,
  //         Country: country,
  //         New: counts.new,
  //         Pending: counts.pending,
  //         Reassigned: counts.reassigned,
  //         Completed: counts.completed,
  //       });
  //     });
  //   });

  //   // Add total row
  //   summaryRows.push({
  //     Client: "Total",
  //     Country: "",
  //     New: totalCounts.new,
  //     Pending: totalCounts.pending,
  //     Reassigned: totalCounts.reassigned,
  //     Completed: totalCounts.completed,
  //   });

  //   // Create detailed labels sheet data
  //   Object.entries(filteredData).forEach(([category, countries]) => {
  //     Object.entries(countries).forEach(([country, stats]) => {
  //       country = country === "GER" ? "DE" : country;

  //       const pushRows = (labels, status) => {
  //         if (labels) {
  //           labels.forEach((label) => {
  //             detailRows.push({
  //               Client: category,
  //               Country: country,
  //               Label: label,
  //               Status: status,
  //             });
  //           });
  //         }
  //       };

  //       pushRows(stats.F, "New");
  //       pushRows(stats.N, "Pending");
  //       pushRows(stats.R, "Reassigned");
  //       pushRows(stats.Y, "Completed");
  //     });
  //   });

  //   // Convert to worksheet
  //   const summarySheet = XLSX.utils.json_to_sheet(summaryRows);
  //   const detailSheet = XLSX.utils.json_to_sheet(detailRows);

  //   // Create workbook
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, summarySheet, "Summary");
  //   XLSX.utils.book_append_sheet(wb, detailSheet, "Label Details");

  //   // Export to file
  //   const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   saveAs(
  //     new Blob([wbout], { type: "application/octet-stream" }),
  //     "MasterLabelReport.xlsx"
  //   );
  // }

  const handleExportToExcel = () => {
    const summaryRows = [];
    const detailRows = [];

    Object.entries(filteredData)
      .sort(([clientA], [clientB]) => clientA.localeCompare(clientB))
      .forEach(([client, countries]) => {
      Object.entries(countries)
        .sort(([countryA], [countryB]) => {
          const nameA = countryA.split("#")[0];
          const nameB = countryB.split("#")[0];
          return nameA.localeCompare(nameB);
        })
        .forEach(([country, stats]) => {
        const { name, code } = getCountryParts(country);
        const counts = calculateCounts(stats);
        const total = Object.values(counts).reduce((a, b) => a + b, 0);
        if (!total) return;

        summaryRows.push({
          Client: client,
          Country: name,
         "Country Code": code,
          New: counts.new,
          Pending: counts.pending,
          Reassigned: counts.reassigned,
          Completed: counts.completed,
          InputLabels : counts.inputLabels,
          WorkInProgress:counts.workInProgress,
          Excluded: counts.excluded,
          Total: counts.total
        });

          const pushRows = (labels, status) => {
            labels?.forEach((item) => {
              const [label, rest] = item.split(";");
              const [dateAndVersion, clientName] = (rest || "").split("&&");
              const [reassignedDate, curationDate] = (dateAndVersion || "").split("#");

              const formattedReassignedDate = reassignedDate
                ? reassignedDate.split(" ")[0]
                : "";

              const formattedCurationDate = curationDate
                ? curationDate.split(" ")[0]
                : "";

              const resolvedStatus =
                typeof status === "function" ? status(label) : status;

              detailRows.push({
                Client: client,
                Country: name,
                "Country Code": code,
                Label: label,
                "Client Name" :clientName,
                "Reassigned Date": formattedReassignedDate || "",
                "Curation Date": formattedCurationDate || "",
                Status: resolvedStatus,
              });
            });
          };

        pushRows(stats.F, "New");
        pushRows(stats.N, "Pending");
        pushRows(stats.R, "Reassigned");
        pushRows(stats.Y, "Completed");
        pushRows(stats.C, (label) =>
          isClientCreatedLabel(label) ? "Create-Client" : "Create"
        );
        pushRows(stats.W, "WorkInProgress");
        pushRows(stats.EXCLUDED, "Excluded");


      });
    });

    summaryRows.push({
      Client: "Total",
      Country: "",
      "Country Code": "",
      New: totalCounts.new,
      Pending: totalCounts.pending,
      Reassigned: totalCounts.reassigned,
      Completed: totalCounts.completed,
      InputLabels : totalCounts.inputLabels,
      WorkInProgress:totalCounts.workInProgress,
      Excluded: totalCounts.excluded,
      Total: totalCounts.total

    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(summaryRows), "Summary");
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(detailRows), "Label Details");

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout]), "MasterLabelReport.xlsx");
  };
  
  return (
    <>
      {loader ? (
        <Card className="mt-2">
          <Card.Body>
            <div className="text-center p-3">
              <Spinner animation="border" />
            </div>
          </Card.Body>
        </Card>
      ) : (
        <Card className="mt-2">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <Card.Title as="h5" className="mb-0">
              Master Label Report
            </Card.Title>
            <Button variant="outline-secondary" onClick={() => handleExportToExcel()}>
             <PiMicrosoftExcelLogoFill />
              <span className="ml-2"> Export as Excel</span>
            </Button>
          </Card.Header>
          <Card.Body>
            <Form
              style={{ display: "flex", gap: "20px", marginBottom: "20px" }}
            >
              {/* Client Filter */}
              <Form.Group controlId="clientFilter" style={{ flex: "1" }}>
                <Form.Label>
                  <strong>Filter by Client</strong>
                </Form.Label>
                <Form.Control
                  as="select"
                  value={clientFilter}
                  onChange={(e) => setClientFilter(e.target.value)}
                >
                  <option value="">All Clients</option>
                  {Object.keys(data)
                    .sort((a, b) => a.localeCompare(b))
                    .map((category) => (
                    <option key={category} value={category}>
                      {category}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              {/* Country Filter */}
              <Form.Group controlId="countryFilter" style={{ flex: "1" }}>
                <Form.Label>
                  <strong>Filter by Country</strong>
                </Form.Label>

                <Select
                  isMulti
                  closeMenuOnSelect={false}
                  options={[
                    ...new Set(
                      clientFilter
                        ? Object.keys(data[clientFilter] || {})
                        : Object.values(data).flatMap((countries) =>
                            Object.keys(countries)
                          )
                    ),
                  ]
                    .map((country) => {
                      const [name] = country.split("#");
                      return { value: country, label: name };
                    })
                    .sort((a, b) => a.label.localeCompare(b.label))}
                  value={countryFilter}
                  onChange={(selected) => setCountryFilter(selected || [])}
                  placeholder="Select Countries"
                />
              </Form.Group>
            </Form>

            <Table bordered responsive>
              <thead>
                <tr>
                  <th style={{ backgroundColor: "#f5f5f5" }}>Client</th>
                  <th style={{ backgroundColor: "#f5f5f5" }}>Country</th>
                  <th style={{ backgroundColor: "#f5f5f5" }}>Country Code</th>
                  <th style={{ backgroundColor: "#f5f5f5" }}>{dynamicLabelConfig.InputLabels?dynamicLabelConfig.InputLabels:"Input Labels"}</th>
                  <th style={{ backgroundColor: "#f5f5f5" }}>{dynamicLabelConfig.WorkInProgress?dynamicLabelConfig.WorkInProgress:"Work In Progress"}</th>
                  <th style={{ backgroundColor: "#f5f5f5" }}>{dynamicLabelConfig.New?dynamicLabelConfig.New:"New"}</th>
                  <th style={{ backgroundColor: "#f5f5f5" }}>{dynamicLabelConfig.Pending?dynamicLabelConfig.Pending:"Pending"}</th>
                  <th style={{ backgroundColor: "#f5f5f5" }}>{dynamicLabelConfig.Reassigned?dynamicLabelConfig.Reassigned:"Reassigned"}</th>
                  <th style={{ backgroundColor: "#f5f5f5" }}>{dynamicLabelConfig.Completed?dynamicLabelConfig.Completed:"Completed"}</th>
                   <th style={{ backgroundColor: "#f5f5f5" }}>{dynamicLabelConfig.Excluded?dynamicLabelConfig.Excluded:"Excluded"}</th>
                  <th style={{ backgroundColor: "#f5f5f5" }}>Total</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(filteredData)
                  .sort(([clientA], [clientB]) => clientA.localeCompare(clientB))
                  .map(([category, countries]) =>
                  Object.entries(countries)
                    .sort(([countryA], [countryB]) => {
                      const nameA = countryA.split("#")[0];
                      const nameB = countryB.split("#")[0];
                      return nameA.localeCompare(nameB);
                    })
                    .map(([country, stats]) => {
                    const counts = calculateCounts(stats);
                    const total = Object.values(counts).reduce(
                      (sum, count) => sum + count,
                      0
                    );
                    if (total === 0) return [];
                    country = country === "GER" ? "DE" : country;
                    return (
                      <tr key={`${category}-${country}`}>
                        <td>{category}</td>
                        <td>{country.split("#")[0]}</td>
                        <td>{country.split("#")[1] === "GER" ? "DE" : country.split("#")[1]}</td>
                         <td>{counts.inputLabels}</td>
                        <td>{counts.workInProgress}</td>
                        <td>{counts.new}</td>
                        <td>{counts.pending}</td>
                        <td>{counts.reassigned}</td>
                        <td>{counts.completed}</td>
                        <td>{counts.excluded}</td>
                        <td><strong>{counts.total}</strong></td>
                      </tr>
                    );
                  })
                )}
                <tr style={{ fontWeight: "bold" }}>
                  <td colSpan="2">Total</td>
                  <td></td>
                  <td>{totalCounts.inputLabels}</td>
                  <td>{totalCounts.workInProgress}</td>
                  <td>{totalCounts.new}</td>
                  <td>{totalCounts.pending}</td>
                  <td>{totalCounts.reassigned}</td>
                  <td>{totalCounts.completed}</td>
                  <td>{totalCounts.excluded}</td> 
                   <td><strong>{grandTotal}</strong></td>
                </tr>
              </tbody>
            </Table>
            <div style={{ height: "30px" }}></div>
                <Table bordered variant="transparent" responsive style={{ tableLayout: "fixed", width: "100%" }}>
  <thead>
    <tr>
      <th style={{ ...tableHeaderStyle, width: "90px" }}>Client</th>
      <th style={{ ...tableHeaderStyle, width: "60px" }}>Country</th>
      <th style={{ ...tableHeaderStyle, width: "60px", textAlign: "center" }}>Country Code</th>
      <th style={{ ...tableHeaderStyle, width: "130px" }}>Label</th>
      <th style={{ ...tableHeaderStyle, width: "120px" }}>Client Name</th>
      <th style={{ ...tableHeaderStyle, width: "90px" }}>1st Reassign</th>
      <th style={{ ...tableHeaderStyle, width: "90px" }}>2nd Reassign</th>
      <th style={{ ...tableHeaderStyle, width: "90px" }}>3rd Reassign</th>
      <th style={{ ...tableHeaderStyle, width: "100px" }}>Curation Date</th>
      <th style={{ ...tableHeaderStyle, width: "95px" }}>Status</th>
    </tr>
  </thead>

  <tbody>
    {Object.entries(filteredData)
      .sort(([clientA], [clientB]) => clientA.localeCompare(clientB))
      .flatMap(([category, countries]) =>
      Object.entries(countries)
        .sort(([countryA], [countryB]) => {
          const nameA = countryA.split("#")[0];
          const nameB = countryB.split("#")[0];
          return nameA.localeCompare(nameB);
        })
        .flatMap(([country, stats]) => {
        country = country === "GER" ? "DE" : country;
        const rows = [];

        /* ---------- helpers ---------- */
        const formatDate = (dateStr) => {
          if (!dateStr) return "";
          const date = new Date(dateStr.trim().replace(" ", "T"));
          return isNaN(date.getTime())
            ? ""
            : date.toISOString().split("T")[0];
        };

        const getDateDiffInDays = (dates) => {
          if (!dates) return null;
          const parts = dates.split("%");
          const latestDateStr = (parts.length > 1 ? parts[1] : parts[0]).trim();
          const date = new Date(latestDateStr.replace(" ", "T"));
          if (isNaN(date.getTime())) return null;
          return (new Date() - date) / (1000 * 60 * 60 * 24);
        };

        const getReassignedDates = (dates) => {
          if (!dates) return [];

          const parts = dates.split("%");

          const oldDates = parts[0]
            ? parts[0].split(",").map((d) => d.trim()).filter(Boolean)
            : [];

          const latestDate = parts[1]?.trim();

          return latestDate ? [...oldDates, latestDate] : oldDates;
        };

        const renderRow = (labelWithDate, status, index, highlight = false) => {
         const [label, rest] = labelWithDate.split(";");
        const [dateAndVersion, clientName] = (rest || "").split("&&");
        const [reassignedDate, curationDate] = (dateAndVersion || "").split("#");

          const datesArray = getReassignedDates(reassignedDate);

          const lastThree = datesArray.slice(-3);

          const first = lastThree[0];
          const second = lastThree[1];
          const third = lastThree[2]; // latest

          const diffDays = highlight ? getDateDiffInDays(reassignedDate) : null;
          const isRed = diffDays !== null && diffDays > 3;
          return (
              <tr key={`${category}-${country}-${status}-${index}`}>

                <td style={{ ...tableCellStyle, width: "90px" }}>{category}</td>

                <td style={{ ...tableCellStyle, width: "60px" }}>
                  {country.split("#")[0]}
                </td>

                <td style={{ ...tableCellStyle, width: "60px", textAlign: "center" }}>
                  {country.split("#")[1] === "GER" ? "DE" : country.split("#")[1]}
                </td>

                {/* Label */}
                <td
                  style={{
                    ...tableCellStyle,
                    width: "130px",
                    color: isRed ? "red" : "inherit",
                    fontWeight: isRed ? "bold" : "normal",
                  }}
                >
                  {label}
                </td>

                {/* Client */}
                <td style={{ ...tableCellStyle, width: "120px" }}>
                  {clientName}
                </td>

                <td style={{ ...tableCellStyle, width: "90px" }}>{formatDate(first)}</td>
                <td style={{ ...tableCellStyle, width: "90px" }}>{formatDate(second)}</td>
                <td style={{ ...tableCellStyle, width: "90px" }}>{formatDate(third)}</td>

                <td style={{ ...tableCellStyle, width: "100px" }}>
                  {formatDate(curationDate)}
                </td>

                <td style={{ ...tableCellStyle, width: "95px" }}>
                  {status}
                </td>

              </tr>
            );

        };

        /* ---------- Status Mapping ---------- */

        if (stats.C) {
          stats.C.forEach((item, i) => {
            const [label] = item.split(";");
            console.log(label)
            rows.push(
              renderRow(
                item,
                isClientCreatedLabel(label) ? "Create-Client" : "Create",
                i
              )
            );
          });
        }

        if (stats.W) {
          stats.W.forEach((item, i) =>
            rows.push(renderRow(item, "Work In Progress", i))
          );
        }

        if (stats.F) {
          stats.F.forEach((item, i) =>
            rows.push(renderRow(item, "New", i))
          );
        }

        if (stats.N) {
          stats.N.forEach((item, i) =>
            rows.push(renderRow(item, "Pending", i))
          );
        }

        if (stats.R) {
          stats.R.forEach((item, i) =>
            rows.push(renderRow(item, "Reassigned", i, true))
          );
        }

        if (stats.Y) {
          stats.Y.forEach((item, i) =>
            rows.push(renderRow(item, "Completed", i))
          );
        }

         if (stats.EXCLUDED) {
          stats.EXCLUDED.forEach((item, i) =>
            rows.push(renderRow(item, "Excluded", i))
          );
        }
        return rows;
      })
    )}
  </tbody>
</Table>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default MasterLabelReportSimplified;
